import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import propMessages from './messages/LicenseProps';

import { InfoList, InfoRow, Key, Value } from '../../components/InfoList';

const propTypes = {
  detailed: PropTypes.bool,
  license: PropTypes.object.isRequired,
  visibleFields: PropTypes.array,
};

const defaultProps = {
  detailed: true,
  visibleFields: null,
};

const LicenseInfo = ({ detailed, license, visibleFields }) => {
  const VISIBLE_FIELDS_CONTINUOUS_SUPPRESSED = [
    'licenseType.name',
    'contactPerson.name',
  ];
  const VISIBLE_FIELDS_CONTINUOUS_DETAILED = [
    ...VISIBLE_FIELDS_CONTINUOUS_SUPPRESSED,
    'license.startDate',
    'license.continuous',
    'license.customerReference'
  ];
  const VISIBLE_FIELDS_NON_CONTINUOUS_SUPPRESSED = [
    'licenseType.name',
    'contactPerson.name',
  ];
  const VISIBLE_FIELDS_NON_CONTINUOUS_DETAILED = [
    ...VISIBLE_FIELDS_NON_CONTINUOUS_SUPPRESSED,
    'license.startDate',
    'license.endDate',
    'license.customerReference'
  ];
  let fields;
  if (detailed) {
    fields = visibleFields || (
      license.data.continuous
      ? VISIBLE_FIELDS_CONTINUOUS_DETAILED
      : VISIBLE_FIELDS_NON_CONTINUOUS_DETAILED);
  } else {
    fields = visibleFields || (
      license.data.continuous
      ? VISIBLE_FIELDS_CONTINUOUS_SUPPRESSED
      : VISIBLE_FIELDS_NON_CONTINUOUS_SUPPRESSED);
  }
  if (license.billingBackend !== 'lima') {
    // Do not show the price of the license if the billing is not done
    // via LiMa. E.g. 0100100 licenses.
    const index = fields.indexOf('license.priceNoVat');
    if (index > -1) {
      fields.splice(index, 1);
    }
  }

  return (
    <React.Fragment>
      <InfoList id={`license-${license.id}-info`}>
        {fields.map(f =>
          <InfoRow
            className={`license-info-${f}`}
            key={`${license.id}-${f}`}
          >
            <Key><FormattedMessage {...propMessages[f]} /></Key>
            <Value>{license.toPrintable(f)}</Value>
          </InfoRow>
        )}
      </InfoList>
    </React.Fragment>
  );
};

LicenseInfo.propTypes = propTypes;
LicenseInfo.defaultProps = defaultProps;

export default LicenseInfo;
